/** @format */

import { createSelector } from 'reselect';

const selectPairingModel = (state) => state.pairingModel;

export const selectpairingModelParameters = createSelector(
  [selectPairingModel],
  (pairingModel) => pairingModel.parameters
);

export const selectPairingModelCrewCount = createSelector(
  [selectPairingModel],
  (pairingModel) => pairingModel.crew_count
);

export const selectPairingModelLoading = createSelector(
  [selectPairingModel],
  (pairingModel) => pairingModel.loading
);

export const selectPairingModelAvailableModels = createSelector(
  [selectPairingModel],
  (pairingModel) => pairingModel.availableModels
);

export const selectPairingModelSelectedModel = createSelector(
  [selectPairingModel],
  (pairingModel) => pairingModel.selectedModel
);

export const selectPairingModelSelectedModelData = createSelector(
  [selectPairingModel],
  (pairingModel) => pairingModel.selectedModelData
);

export const selectPairingModelSelectedModelDetails = createSelector(
  [selectPairingModel],
  (pairingModel) => pairingModel.selectedModelDetails
);
